import axios from 'axios';

/**
 * Admin sign-in.
 *
 * The password is checked on the server — it never lives in this bundle. What
 * we keep here is the short-lived token the server hands back, and we attach
 * it to every request so the admin endpoints will answer.
 */

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
const TOKEN_KEY = 'admin_token';

export const getAdminToken = () => sessionStorage.getItem(TOKEN_KEY);
export const clearAdminToken = () => sessionStorage.removeItem(TOKEN_KEY);

export const signIn = async (password) => {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  sessionStorage.setItem(TOKEN_KEY, data.token);
  return data;
};

/** True if the stored token is still accepted by the server. */
export const hasValidSession = async () => {
  if (!getAdminToken()) return false;
  try {
    await axios.get(`${API}/admin/session`);
    return true;
  } catch {
    clearAdminToken();
    return false;
  }
};

let installed = false;

/** Send the token on every request, and drop it the moment the server rejects it. */
export const installAdminAuth = () => {
  if (installed) return;
  installed = true;

  axios.interceptors.request.use((config) => {
    const token = getAdminToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const url = error.config?.url || '';
      const isSignInAttempt = url.includes('/admin/login') || url.includes('/admin/session');
      // A rejected sign-in is for the form to report. A 401 anywhere else means
      // the session ran out mid-use, so send them back to the gate.
      if (error.response?.status === 401 && !isSignInAttempt) {
        clearAdminToken();
        if (window.location.pathname.startsWith('/admin')) {
          window.location.reload();
        }
      }
      return Promise.reject(error);
    }
  );
};
